module.exports = __webpack_public_path__ + "static/media/3DPPA42.7af1899e.jpg";